import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
// import { SalesInvoiceService } from "../../../services/salesinvoice.service";
import { Combo2Service, WorkOrderService } from "../../../services/index";
import { SalesInvoiceService } from "../../../services/salesinvoice.service";
import { PartyService, SalesPlanService, PurchaseOrderService } from "../../../services/index";
import { SalesOrderService } from "../../../services/salesOrder.service";


@Component({
  selector: "addEditInvoice",
  templateUrl: "./addpoplainplan.html",
})
export class addPoplanComponent {
  @ViewChild("tbody1") tbody1;
  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  row: any;
  data: any;
  menu: any;
  agentdata: any;
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };
  qualityList: any;
  typeList: any;
  year_id : any;
  codeList: any;
  execApi: boolean = true;
  show_det: boolean = true;
  seasonfinList = [];
  temp: any = {};
  invoicedata: any = {
    design_no: "",
    agent_name: "",
    fin_id: "",
    season: "",
    season_id: "",
    planQty : 0
  };
  delPartyList: any;
  party_id: any;
  box: any;
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  designList: any;
  invalidList: any = [];
  seasonList: any = [];

  colorList: any = [];
  agentEntry: any = [];
  seasonyearList = [];
  newDesignList = [];
  dataList = [];
  Agentlist = [];
  finyearList = [];
  fabColorlist: any = [];
  fabColorTemplist: any = [];
  invoiceTypeList = ["PROFORMA", "INVOICE"];
  fabstyleList = ["PLAIN", "MAPLE", "PLAIN DOBBY", "PRINTED", "CHECKS", "STRIPES"];
  widthList = ["36", "44", "58"];
  brandList = ["EXPOSE", "ARAZA"];
  styleList = ["FORMAL", "CASUAL"];
  fitList = ["COMFORT FIT", "RELAX FIT"];
  mode: string;
  saveEvent: any;
  agentList: any;
  date_id : any
  bl = [];
  partyCodeList: any;
  isLoading: boolean = false;
  isChecked: boolean = false;
  seasonShow: string;
  sampleList = [{ name: "YES" }, { name: "NO" }];

  partyList = [];
  partyOrderno: any;
  order: any;
  sale_type: any;
  expand = true;
  to_sale_type: any;
  listSelected = [];
  isLoadMask: Promise<any>;
  @Input() _params: any;

  @Input() set params(val: any[]) {
    if (_.isEmpty(val)) {
      let row: any = {};
      row.tabevent = new EventEmitter();
      let tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD AGENT DEDUCTION",
          title: "ADD AGENT DEDUCTION",
          tabParent: "SALES_ORDER",
          mode: "Add",
          data: row,
          name: "ADD AGENT DEDUCTION",
        },
      };
      this._params = tabObj;
      val = this._params;
      this.mode = tabObj.params.mode;
      this.saveEvent = row.tabevent;
      let invoicedata = Object.assign({}, tabObj.params["data"]);
      // this.acdata = designdata;
    } else {
      this._params = val;
      this.mode = val["mode"];
      this.sale_type = val["sale_type"];
      this.to_sale_type = val["to_sale_type"];
      this.saveEvent = val["data"].tabevent;
      let invoicedata = Object.assign({}, val["data"]);
      this.invoicedata.ord_from = invoicedata.ord_from;
       this.invoicedata.ord_to = invoicedata.ord_to;
      this.invoicedata.design_no  = invoicedata.design_no
      console.log("check", val, "check Object", this.invoicedata)
       val["data"] = {};
    }
    if (this.mode == "Convert") {
      this.invoicedata.mode = "Add";
    }

    if (this.mode == "Convert") {
      //  this.editInvoiceList();
      this.invoicedata.ref_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      //   this.oncheck(this.invoicedata.salesorder);
    }
    if (this.mode == "View" || this.mode == "Edit") {

    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("codeAuto") codeAuto;
  widthCtrl: FormControl = new FormControl();
  finCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  OrderNoCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    // private salesinvservice: WorkOrderService,
    private salesinvservice: SalesPlanService,
    private salesOrderServ: SalesOrderService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private poservice: PurchaseOrderService,
    private combo2Service: Combo2Service,
    private partyService: PartyService
  ) {
    this.row = {
      agent_name: "",
      shade: "",
      color: "",
      fab_no: "",
      fab_color: "",
      style: "",
      brand: "",
      sam_no: "",
    };
    this.data = {
      invoiceList: [],
    };
  }
  ngOnInit() {
    this.tableScroll();
    this.invoicedata.mode = this.mode;
    this.finyearCombo()
    this.getNewDesignList()
    if (this.mode == "Add") {
      this.invoicedata.ref_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    }

    this.data.invoiceList = [];
  }
  ngAfterViewInit() {
    $("#invoice_type").focus();
  }
  tableScroll() {
    $(".invoiceTable").height(window.innerHeight - 400);
    $(".invoiceTable").width(window.innerWidth - 30);
  }

  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 500);
    }
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind + 1;
  
      setTimeout(() => {
        let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
        a.removeClass("mat-autocomplete-visible");
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);

  }

  isRowEmpty(ind) {
    let data = this.data.invoiceList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }

  colorlist() {
    this.poservice.colorlist({}).then((res: any) => {
      this.colorList = res.data;
    });
  }
  CalcEachPlan(){
     this.data.invoiceList.forEach((e, ind) => {
        e.plan_each = e.ord_per ? ((e.ord_per * Number(this.invoicedata.planQty)) / 100).toFixed(2) : 0
      });
  }
  calcTotal(ind) {
    this.data.invoiceList[ind].avl_tot = Number(this.data.invoiceList[ind].need) + Number(this.data.invoiceList[ind].stk_total)
    this.data.invoiceList[ind].stk_ord_diff = Number(this.data.invoiceList[ind].avl_tot) - Number(this.data.invoiceList[ind].soord_shirts);
    this.temp.need_gr = 0;
    this.temp.avl_gr = 0;
    this.temp.diff_gr = 0;
           
    for (let i = 0; i < this.data.invoiceList.length; i++) {
      const data = this.data.invoiceList[i];
      this.temp.need_gr += Number(data.need)
      this.temp.avl_gr += Number(data.avl_tot)
      this.temp.diff_gr += Number(data.stk_ord_diff)
    };

    this.data.invoiceList[ind].avl_tot_per = this.data.invoiceList[ind].avl_tot ? (Number(this.data.invoiceList[ind].avl_tot) / Number(this.temp.avl_gr) * 100).toFixed(2) : 0
  
  }



  onSelectFinyear(id) {
    this.year_id = id;
    // let seasonfinList = _.filter(this.seasonList, { fin_id: id });
    // this.seasonfinList = seasonfinList;
    // this.seasonCtrl.setValue(
    //   this.seasonList[this.seasonList["length"] - 1].season_id
    // );
    // this.onSelectdate('ALL');
    this.selectYear()
    console.log(this.date_id);
  }
  displayFinyear(comboType: string, id: number) {

    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  displayFn(id: number) {
    // this.date_id = id;
    // console.log(this.date_id);
    let list: any = [];
    let that = this;
    list = that.seasonList;

    if (id && list.length > 0) {
      let fitem = _.find(list, { season_id: id });
      this.seasonShow = fitem["season"];
      return fitem["season"];
    }
    return "";
  }
  onSelectdate(type) {
 

      // let fest_id = this.date_id;
      let data = this.seasonList;
      let obj = data.find(o => o.season === type);
      this.invoicedata.ord_from = obj.ord_start;
      this.invoicedata.ord_to = obj.ord_end;
      this.invoicedata.season_id = obj.season_id
  }

  getMasterDetails() {

     this.invoicedata.ord_from = this.datePipe.transform(this.invoicedata.ord_from, 'yyyy-MM-dd');
      this.invoicedata.ord_to = this.datePipe.transform(this.invoicedata.ord_to, 'yyyy-MM-dd');

    let params : any = Object.assign({}, this.invoicedata)
    this.data.invoiceList = [];
    this.salesinvservice.getplainPosummary(params).then((res: any) => {
     
      this.data.invoiceList = res.data;
      let tot_order = 0;
      this.data.invoiceList.forEach((e,ind) => {
        tot_order += Number(e.soord_shirts);
        console.log(Number(e.soord_shirts), ":: check Numbeeeeeeeeeer",tot_order)
      });
        this.data.invoiceList.forEach((e,ind) => {
          e.stk_per =  e.soord_shirts ? ((e.stk_total * 100)/ e.soord_shirts).toFixed(2) : ''
          e.ord_per =  e.soord_shirts ? ((e.soord_shirts * 100)/ tot_order).toFixed(2) : ''
          console.log("for stk_per ::",e.stk_total,e.soord_shirts);
  
          // console.log("for ord_per ::",e.soord_shirts,e.stk_total);
        });
      // console.log("data.invoiceList", this.data.invoiceList);
      this.calcGrandtot();
      var bottom = document.querySelector("#salesTbody");
      setTimeout(() => {
        bottom.scrollTop = bottom.scrollHeight;
      }, 500);
      // this.selectYear();
      // if(!this.show_det)
      //  this.calcInchargerTot(this.data.invoiceList);
    });
  }

  selectYear() {
    this.seasonList = [];
    this.invoicedata.season = '';
    let obj = this.finyearList.find(o => o.fin_id === this.invoicedata.fin_id);
    let params = {
      year: obj.fin_id,
    };
    this.salesinvservice.getyearSeason(params).then((res: any) => {
      this.seasonList = res;
      console.log("seasonList", this.seasonList);
    });
  }
  calcGrandtot() {
    // if (this.show_det) {
      let stk_gr = 0;
      let need_gr = 0;
      let avl_gr = 0;
      let po_gr = 0;
      let fab_gr = 0;
      let wo_gr = 0;
      let war_gr = 0;

      let diff_gr = 0;
      let ord_gr = 0;
      let sopend_gr = 0;

      for (let i = 0; i < this.data.invoiceList.length; i++) {
        const data = this.data.invoiceList[i];
        stk_gr += Number(data.stk_total)
        po_gr += Number(data.popend_shirts)
        need_gr += Number(data.need)
        avl_gr += Number(data.avl_tot)
        wo_gr += Number(data.wo_tot)
        fab_gr += Number(data.tex_shirts)
        war_gr += Number(data.wr_tot)
        diff_gr += Number(data.stk_ord_diff)
        ord_gr += Number(data.soord_shirts)
        sopend_gr += Number(data.sopend_shirts)
        
      }
     
      this.temp.agent_name = "GRAND TOTAL";
      this.temp.stk_gr = stk_gr;
      this.temp.po_gr = po_gr;
      this.temp.need_gr = need_gr;
      this.temp.avl_gr = avl_gr;
      this.temp.wo_gr = wo_gr;
      this.temp.fab_gr = fab_gr;
      this.temp.war_gr = war_gr;
      this.temp.diff_gr = diff_gr;
      this.temp.ord_gr = ord_gr;
      this.temp.sopend_gr = sopend_gr;

    this.data.invoiceList.forEach((e, ind) => {
        e.avl_tot_per = e.avl_tot ? ((e.avl_tot / Number(this.temp.avl_gr)) * 100).toFixed(2) : 0
      });
  }

  Onselectagent(type) {
    let temp = this.Agentlist.filter(el => el.name == type);
    this.agentdata = temp[0].genLedid;
    // console.log(this.agentdata)

  }
  // rowStyle(ind) {
  //   let style = {};
  //   if (this.show_det) {
  //     if ((this.data.invoiceList.length - 1) === ind) {
  //       style = {
  //         font: "caption",
  //         background: "red"
  //       };  
  //     }
  //   }
  //   else{
  //     style = {
  //       font: "caption",
  //       backround: "grey"
  //     };
  //   }

  //   return style;
  // }
  getagent() {
    let params = {
      incharger: this.menu.param,
    };
    this.salesinvservice.getSalesagent(params).then((res: any) => {
      this.Agentlist = res;
      console.log("Agentlist", this.Agentlist);
    });
  }

  onnextdet() {
    this.show_det = true;  
    this.data.invoiceList.splice(this.data.invoiceList.length - 1)
    this.agentEntry = this.data.invoiceList;
    console.log(this.agentEntry,"check Agententryyyyyy")
    this.calcInchargerTot(this.agentEntry)
    this.getMasterDetails()
  }
  onbackdet() {
    this.show_det = false;
    // this.agentEntry.splice(this.agentEntry.length - 1)
    this.data.invoiceList = this.agentEntry;
  }
  getViewShade(type) {
    this.mode = 'Add'
    let ind = type;
    let params = {
      des_id: this.data.invoiceList[ind].des_id
    };
    this.show_det = false;
  }
  calcInchargerTot(Inchdata){
    let data = {
      incharger: 'GRAND TOTAL',
      a1: 0,
      a2: 0,
      a3: 0,
      a4: 0,
      // a5: 0,
      ord_total_target: 0,
      total: 0
    }
    Inchdata.forEach(e => {
      data.a1 += Number(e.a1)
      data.a2 += Number(e.a2)
      data.a3 += Number(e.a3)
      data.a4 += Number(e.a4)
      // data.a5 += Number(e.a5)
      // data.a5 += Number(e.a5)
      data.ord_total_target += Number(e.ord_total_target)
      data.total += Number(e.total)

    });
    Inchdata.push(data)
  }
  checkAll(evant, all) {
    if (evant.target.checked) {
      this.listSelected = this.data.invoiceList;
      $("input:checkbox").prop("checked", evant.target.checked);
    } else {
      $("input:checkbox").prop("checked", evant.target.checked);
      this.listSelected = [];
    }
  }
  checkInd(evant, ind, all) {
    if (evant.target.checked) {
      this.listSelected.push(all.data.invoiceList[ind]);
    } else {
      for (var k = 0; k < this.listSelected.length; k++) {
        if (
          this.listSelected[k].agent_name == all.data.invoiceList[ind].agent_name
        ) {
          this.listSelected.splice(k, 1);
          return;
        }
      }
    }
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getEditMode(ind) {
    this.mode = 'Edit';
  }

  getTbodyStyle() {
    let height = 300;
    if (this.tbody1) {
      height -= this.tbody1.nativeElement.offsetHeight;
    }
    const style = {
      display: "block",
      width: "1px",
      height: height + "px",
      "overflow-y": "scroll",
    };
    return style;
  }
  checkagent_name(code) {
    if (code.length == 6) {
      if (this.execApi) {
        this.execApi = false;

        let params = {
          agent_name: code,
        };
        for (let i = 0; i < this.data.invoiceList.length; i++) {
          if (this.data.invoiceList[i].agent_name == code) {
            setTimeout(() => {
              this.invoicedata.agent_name = "";
              $("#code").focus();
            }, 500);

            swal({
              title: "agent_name Already Exists",
              timer: 1000,
              type: "warning",
              showCancelButton: false,
              showConfirmButton: false,
            });
            this.execApi = true;
            return;
          }
        }
      }
    }
  }
  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      this.finyearCtrl.setValue(res.data[0].fin_id);
      that.invoicedata.finyear = res.data[0].finyear;
      that.invoicedata.fin_id = res.data[0].fin_id;
      this.selectYear();
    });
  }
  getNewDesignList() {
    this.salesOrderServ.getNewDesignList({}).then((res: any) => {
      this.newDesignList = res;
    });
  }
  oncheckemptyrow() {
    let params: any = Object.assign({}, this.invoicedata);
    params["tabevent"] = undefined;

    params["data"] = JSON.stringify(this.data.invoiceList);
    params["type"] = this.menu.param;

    let that = this;
 
    swal({
      title: "Are You Sure To Save The Details?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Ok,Proceed!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isLoadMask = that.salesinvservice
        .savePoplanDetails(params)
        .then(function (res: any) {
          if (that.saveEvent) {
            that.saveEvent.emit();
          }
          if (res.success) {
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
            if (that.mode == "Add") {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            } else {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            }
          }
          else {
            swal(res.message);
          }
        })
        .catch(function (error: any) {
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
  }

}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/poplan/addpoplainplan.ts